import { render } from "./LocationSite.vue?vue&type=template&id=b4cb7ce6&ts=true"
import script from "./LocationSite.vue?vue&type=script&lang=ts"
export * from "./LocationSite.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__